export const siteSettings = {
  name: "Next Level Trade",
  link: "https://nextleveltrades.live",
  email: "support@nextleveltrades.live",
  appLink: "https://app.nextleveltrades.live",
};
